<div [id]="id" class="dropdown multi-select-dropdown">
    <button class="btn button-common" [ngClass]="{'button-regular': !alternateLook, 'button-alternate': alternateLook}"
        type="button" data-bs-toggle="dropdown" aria-expanded="false" [disabled]="disabled || items.length == 0"
        [ngStyle]="{ 'border-radius': borderRadius }">
        <span class="value-text" *ngIf="!selectedItem" [style.color]="textColor || null">{{label | translate}}</span>
        <span class="value-text" *ngIf="selectedItem && showMore" [style.color]="textColor || null">{{seletedLabel}}</span>
        <span class="value-text" *ngIf="selectedItem && !showMore" [style.color]="textColor || null">{{seletedLabel.split(',')}}</span>
        <div class="arrow-box">
            <i *ngIf="!alternateLook" class="arrow-custom --xsmall down"></i>
            <img *ngIf="alternateLook" src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" />
        </div>
    </button>
    <ul class="dropdown-menu">
        <div class="search-input" *ngIf="searchFilterActive === true">
            <img src="../../assets/icons/search.svg" alt="Search icon" />
            <input type="text" placeholder="Search..." [(ngModel)]="searchValue"
                (input)="applySearchFilter(searchValue)" />
        </div>
        <div *ngIf="searchFilterActive" class="dropdown-items">
            <button type="button" class="dropdown-item" [id]="id + '_search_filter_active-' + (i + 1)"
                *ngFor="let item of items | slice:0:maxDisplayItems; let i = index"
                (mousedown)="getSelectedValue(getItemValue(item))" (click)="getSelectedValue(getItemValue(item))">
                <span>{{getDisplayValue(item)}}</span>
            </button>
        </div>
        <div *ngIf="!searchFilterActive" class="dropdown-items">
            <button type="button" class="dropdown-item" [id]="id + '_search_filter_not_active-' + (i + 1)"
                *ngFor="let item of items; let i = index"
                (mousedown)="getSelectedValue(getItemValue(item))" (click)="getSelectedValue(getItemValue(item))">
                <span>{{getDisplayValue(item)}}</span>
            </button>
        </div>
    </ul>
</div>